module.exports = __webpack_public_path__ + "img/RACKS.1c32ba77.png";